import axios from "../axios";

const getTop = async function (accessToken, params = {}) {
    try {
        const response = await axios.post('pay-in/getTop', params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getTop; 
